import type { LocalizedCopy } from "../productCopyTypes";

function paragraphs(text: string): string {
  return text
    .split(/\n\n+/)
    .map((p) => p.trim())
    .filter(Boolean)
    .map((p) => `<p>\n${p}\n</p>`)
    .join("\n\n");
}

function featureList(items: string[]): string {
  return `<ul>\n${items.map((item) => `  <li>${item}</li>`).join("\n")}\n</ul>`;
}

const COPY = {
  en: {
    title: "Car series",
    description:
      "Bring the excitement of post-apocalyptic action to your collection with the 12GO 95005 CAR SERIES. This premium building set features two highly detailed custom vehicles inspired by the rugged machines of a dystopian wasteland. With 1,726 precision-engineered building pieces, it delivers an immersive building experience and creates two striking display models packed with aggressive styling and mechanical details.\n\nEvery vehicle is filled with unique design elements, including exposed engines, reinforced armor, oversized exhaust systems, roof-mounted equipment, custom accessories, and detailed interiors. The larger off-road machine features massive tires, an elevated suspension, and dramatic rear banners, while the companion muscle car combines a classic body shape with a heavily modified post-apocalyptic appearance.\n\nThe models are designed with modular sections, allowing builders to remove selected body panels and admire the detailed construction underneath. Rich mechanical detailing, realistic cockpit features, and bold styling make this set an outstanding display piece for any collection.\n\nWhether you're a fan of custom cars, action-inspired vehicles, or simply enjoy advanced building projects, the 12GO 95005 CAR SERIES offers an engaging challenge and an impressive result worthy of display.",
    highlightsTitle: "Key Features",
    features: [
      "1,726 high-quality building pieces",
      "Includes two post-apocalyptic custom vehicles",
      "Highly detailed engines and mechanical components",
      "Modular construction for easier display and access",
      "Detailed interiors with realistic cockpit features",
      "Aggressive off-road styling with oversized tires and custom accessories",
      "Display-worthy models with premium visual detail",
      "Compatible with building bricks from other major brands",
      "Ideal for collectors, vehicle enthusiasts, and experienced builders",
      "A rewarding building experience for older children and adults",
    ],
    specsTitle: "Product Features",
    specs: [
      "<li><strong>Brand:</strong> 12GO</li>",
      "<li><strong>Model:</strong> CAR SERIES</li>",
      "<li><strong>Item Number:</strong> 95005</li>",
      "<li><strong>Piece Count:</strong> 1726+ pieces</li>",
      "<li><strong>Recommended Age:</strong> 14+</li>",
    ],
  },
  pl: {
    title: "Car series",
    description:
      "Przenieś klimat postapokaliptycznych przygód do swojej kolekcji dzięki zestawowi 12GO 95005 CAR SERIES. Ten rozbudowany model zawiera dwa wyjątkowe pojazdy inspirowane maszynami z dystopijnego świata. Zestaw składa się z 1726 precyzyjnie wykonanych elementów, zapewniając wymagającą i satysfakcjonującą budowę oraz dwa efektowne modele kolekcjonerskie.\n\nKażdy pojazd został wyposażony w liczne detale, takie jak odkryte silniki, wzmocnione pancerze, potężne układy wydechowe, wyposażenie dachowe, akcesoria oraz szczegółowo wykonane wnętrza. Większy pojazd terenowy wyróżnia się ogromnymi kołami, podwyższonym zawieszeniem i charakterystycznymi tylnymi flagami, natomiast drugi model prezentuje klasyczną sylwetkę muscle cara w postapokaliptycznej odsłonie.\n\nModułowa konstrukcja umożliwia zdejmowanie wybranych elementów nadwozia i podziwianie bogato odwzorowanych detali. Realistyczne kokpity, mechaniczne elementy i agresywny wygląd sprawiają, że zestaw doskonale prezentuje się na półce.\n\nTo idealna propozycja dla fanów nietuzinkowych samochodów, kolekcjonerów oraz osób szukających zaawansowanego projektu do budowy.",
    highlightsTitle: "Najważniejsze cechy",
    features: [
      "1726 wysokiej jakości elementów",
      "Dwa postapokaliptyczne pojazdy w jednym zestawie",
      "Szczegółowo odwzorowane silniki i elementy mechaniczne",
      "Modułowa konstrukcja ułatwiająca prezentację modeli",
      "Bogato wykonane wnętrza z realistycznymi detalami",
      "Agresywny wygląd z dużymi kołami i licznymi akcesoriami",
      "Modele idealne do ekspozycji",
      "Kompatybilność z klockami innych popularnych producentów",
      "Idealny dla kolekcjonerów i fanów motoryzacji",
      "Satysfakcjonująca budowa dla starszych dzieci i dorosłych",
    ],
    specsTitle: "Cechy zestawu",
    specs: [
      "<li><strong>Marka:</strong> 12GO</li>",
      "<li><strong>Model:</strong> CAR SERIES</li>",
      "<li><strong>Numer katalogowy:</strong> 95005</li>",
      "<li><strong>Liczba elementów:</strong> 1726+</li>",
      "<li><strong>Wiek zalecany:</strong> 14+</li>",
    ],
  },
  es: {
    title: "Car series",
    description:
      "Lleva la emoción de la acción postapocalíptica a tu colección con el 12GO 95005 CAR SERIES. Este impresionante set incluye dos vehículos personalizados inspirados en un mundo distópico. Con 1726 piezas de alta calidad, ofrece una experiencia de construcción desafiante y dos espectaculares modelos de exhibición.\n\nCada vehículo cuenta con motores expuestos, blindaje reforzado, grandes sistemas de escape, accesorios personalizados e interiores detallados. El vehículo todoterreno destaca por sus enormes neumáticos y suspensión elevada, mientras que el segundo modelo reinventa un clásico muscle car con un estilo postapocalíptico.\n\nLa construcción modular permite retirar partes de la carrocería para admirar los detalles mecánicos. Es un set perfecto para exponer y disfrutar después del montaje.",
    highlightsTitle: "Características destacadas",
    features: [
      "1726 piezas de alta calidad",
      "Dos vehículos postapocalípticos en un solo set",
      "Motores y componentes mecánicos detallados",
      "Construcción modular",
      "Interiores realistas",
      "Diseño todoterreno agresivo",
      "Excelente modelo para exhibición",
      "Compatible con otras marcas populares",
      "Ideal para coleccionistas y aficionados a los vehículos",
      "Construcción entretenida para adultos y niños mayores",
    ],
    specsTitle: "Características del producto",
    specs: [
      "<li><strong>Marca:</strong> 12GO</li>",
      "<li><strong>Modelo:</strong> CAR SERIES</li>",
      "<li><strong>Número de artículo:</strong> 95005</li>",
      "<li><strong>Piezas:</strong> 1726+</li>",
      "<li><strong>Edad recomendada:</strong> 14+</li>",
    ],
  },
  de: {
    title: "Car series",
    description:
      "Erlebe die Welt der postapokalyptischen Fahrzeuge mit dem 12GO 95005 CAR SERIES. Dieses hochwertige Set enthält zwei außergewöhnliche Fahrzeuge im dystopischen Stil. Mit 1726 hochwertigen Bausteinen bietet es ein anspruchsvolles Bauerlebnis und zwei beeindruckende Ausstellungsmodelle.\n\nBeide Fahrzeuge verfügen über freiliegende Motoren, verstärkte Karosserieteile, große Auspuffanlagen, zahlreiche Anbauteile und detailreiche Innenräume. Das größere Fahrzeug besitzt riesige Offroad-Reifen und eine erhöhte Federung, während das zweite Modell den Look eines klassischen Muscle Cars neu interpretiert.\n\nDank der modularen Bauweise lassen sich einzelne Karosserieteile entfernen, um die aufwendig gestalteten Details zu präsentieren.",
    highlightsTitle: "Wichtige Merkmale",
    features: [
      "1726 hochwertige Bausteine",
      "Zwei postapokalyptische Fahrzeuge",
      "Detailreiche Motoren und Mechanik",
      "Modulare Konstruktion",
      "Realistische Innenausstattung",
      "Aggressives Offroad-Design",
      "Perfekt als Ausstellungsmodell",
      "Kompatibel mit anderen Bausteinmarken",
      "Ideal für Sammler und Fahrzeugfans",
      "Anspruchsvoller Bauspaß für Jugendliche und Erwachsene",
    ],
    specsTitle: "Produkteigenschaften",
    specs: [
      "<li><strong>Marke:</strong> 12GO</li>",
      "<li><strong>Modell:</strong> CAR SERIES</li>",
      "<li><strong>Artikelnummer:</strong> 95005</li>",
      "<li><strong>Teileanzahl:</strong> 1726+</li>",
      "<li><strong>Empfohlenes Alter:</strong> 14+</li>",
    ],
  },
  fr: {
    title: "Car series",
    description:
      "Découvrez l'univers post-apocalyptique avec le 12GO 95005 CAR SERIES. Ce superbe coffret comprend deux véhicules personnalisés inspirés d'un monde dystopique. Avec 1726 pièces de haute qualité, il offre une expérience de construction immersive et deux magnifiques modèles d'exposition.\n\nLes deux véhicules présentent des moteurs apparents, des protections renforcées, de larges échappements, de nombreux accessoires et des intérieurs détaillés. Le plus grand modèle dispose de pneus tout-terrain imposants et d'une suspension surélevée, tandis que le second revisite une voiture classique dans un style post-apocalyptique.\n\nLa conception modulaire permet de retirer certaines parties de la carrosserie pour admirer les nombreux détails mécaniques.",
    highlightsTitle: "Points forts",
    features: [
      "1726 pièces de haute qualité",
      "Deux véhicules post-apocalyptiques",
      "Moteurs et détails mécaniques réalistes",
      "Construction modulaire",
      "Intérieurs détaillés",
      "Style tout-terrain agressif",
      "Parfait pour l'exposition",
      "Compatible avec les principales marques de briques",
      "Idéal pour les collectionneurs",
      "Construction passionnante pour adolescents et adultes",
    ],
    specsTitle: "Caractéristiques",
    specs: [
      "<li><strong>Marque :</strong> 12GO</li>",
      "<li><strong>Modèle :</strong> CAR SERIES</li>",
      "<li><strong>Référence :</strong> 95005</li>",
      "<li><strong>Nombre de pièces :</strong> 1726+</li>",
      "<li><strong>Âge recommandé :</strong> 14+</li>",
    ],
  },
  nl: {
    title: "Car series",
    description:
      "Breng de spanning van een post-apocalyptische wereld naar je verzameling met de 12GO 95005 CAR SERIES. Deze premium bouwset bevat twee indrukwekkende voertuigen geïnspireerd op een dystopische toekomst. Met 1726 hoogwaardige bouwstenen biedt de set een uitdagende bouwervaring en twee opvallende displaymodellen.\n\nBeide voertuigen zijn voorzien van open motoren, versterkte bepantsering, grote uitlaten, accessoires en gedetailleerde interieurs. Het grotere terreinvoertuig beschikt over enorme banden en verhoogde vering, terwijl de tweede auto een klassieke muscle car combineert met een stoere post-apocalyptische uitstraling.\n\nDankzij de modulaire constructie kunnen delen van de carrosserie worden verwijderd om de technische details te bewonderen.",
    highlightsTitle: "Belangrijkste kenmerken",
    features: [
      "1726 hoogwaardige bouwstenen",
      "Twee post-apocalyptische voertuigen",
      "Gedetailleerde motoren en techniek",
      "Modulaire constructie",
      "Realistische interieurs",
      "Stoer offroad-design",
      "Perfect als displaymodel",
      "Compatibel met andere bekende bouwsteenmerken",
      "Ideaal voor verzamelaars",
      "Uitdagende bouwervaring voor oudere kinderen en volwassenen",
    ],
    specsTitle: "Productkenmerken",
    specs: [
      "<li><strong>Merk:</strong> 12GO</li>",
      "<li><strong>Model:</strong> CAR SERIES</li>",
      "<li><strong>Artikelnummer:</strong> 95005</li>",
      "<li><strong>Aantal onderdelen:</strong> 1726+</li>",
      "<li><strong>Aanbevolen leeftijd:</strong> 14+</li>",
    ],
  },
  zh: {
    title: "Car series",
    description:
      "12GO 95005 CAR SERIES 将末日废土风格带入您的积木收藏。套装包含两辆极具特色的定制车辆，灵感源自后末日世界。全套共1726块优质积木，带来沉浸式拼搭体验，并打造两款极具视觉冲击力的展示模型。\n\n两辆车型均拥有丰富的机械细节，包括外露发动机、强化装甲、夸张排气系统、车顶配件以及精致的驾驶舱。大型越野车配备超大轮胎、高离地悬挂和醒目的尾部旗帜，而另一辆经典车型则融入了浓厚的废土改装风格。\n\n模块化设计可拆卸部分车身，方便展示内部机械结构，是收藏和展示的绝佳选择。",
    highlightsTitle: "套装亮点",
    features: [
      "1726块优质积木",
      "包含两辆后末日风格车辆",
      "精致发动机和机械细节",
      "模块化设计",
      "真实还原的驾驶舱",
      "霸气越野外观",
      "极具收藏价值的展示模型",
      "兼容其他主流积木品牌",
      "适合收藏玩家和车辆爱好者",
      "适合大龄儿童及成人拼搭",
    ],
    specsTitle: "产品特点",
    specs: [
      "<li><strong>品牌：</strong>12GO</li>",
      "<li><strong>型号：</strong>CAR SERIES</li>",
      "<li><strong>货号：</strong>95005</li>",
      "<li><strong>颗粒数：</strong>1726+</li>",
      "<li><strong>建议年龄：</strong>14+</li>",
    ],
  },
  it: {
    title: "Serie di auto",
    description:
      "Porta nella tua collezione l'emozione dell'azione post-apocalittica con il 12GO 95005 CAR SERIES. Questo set da costruzione premium include due veicoli personalizzati altamente dettagliati, ispirati alle robuste macchine di una landa desolata distopica. Con 1,726 pezzi da costruzione realizzati con precisione, offre un'esperienza di assemblaggio coinvolgente e permette di creare due spettacolari modelli da esposizione, ricchi di dettagli meccanici e di uno stile aggressivo.\n\nOgni veicolo è caratterizzato da elementi di design unici, tra cui motori a vista, corazze rinforzate, sistemi di scarico sovradimensionati, equipaggiamento montato sul tetto, accessori personalizzati e interni dettagliati. Il robusto veicolo fuoristrada è dotato di pneumatici enormi, sospensioni rialzate e vistosi stendardi posteriori, mentre la muscle car abbina una carrozzeria dalle forme classiche a un look post-apocalittico profondamente modificato.\n\nI modelli sono progettati con sezioni modulari che consentono di rimuovere alcuni pannelli della carrozzeria e ammirare nei dettagli la struttura sottostante. Le ricche rifiniture meccaniche, gli elementi realistici dell'abitacolo e lo stile deciso rendono questo set un eccezionale pezzo da esposizione per qualsiasi collezione.\n\nChe tu sia appassionato di auto personalizzate e veicoli ispirati all'azione o che ami semplicemente i progetti di costruzione avanzati, il 12GO 95005 CAR SERIES offre una sfida coinvolgente e un risultato straordinario, degno di essere esposto.",
    highlightsTitle: "Caratteristiche principali",
    features: [
      "1,726 pezzi da costruzione di alta qualità",
      "Include due veicoli personalizzati post-apocalittici",
      "Motori e componenti meccanici altamente dettagliati",
      "Struttura modulare per facilitare l'esposizione e l'accesso",
      "Interni dettagliati con elementi realistici dell'abitacolo",
      "Stile fuoristrada aggressivo con pneumatici sovradimensionati e accessori personalizzati",
      "Modelli da esposizione con dettagli visivi di livello premium",
      "Compatibile con i mattoncini da costruzione di altri importanti marchi",
      "Ideale per collezionisti, appassionati di veicoli e costruttori esperti",
      "Un'esperienza di costruzione appagante per ragazzi più grandi e adulti",
    ],
    specsTitle: "Caratteristiche del prodotto",
    specs: [
      "<li><strong>Marca:</strong> 12GO</li>",
      "<li><strong>Modello:</strong> CAR SERIES</li>",
      "<li><strong>Codice articolo:</strong> 95005</li>",
      "<li><strong>Numero di pezzi:</strong> 1726+ pezzi</li>",
      "<li><strong>Età consigliata:</strong> 14+</li>",
    ],
  },
  ru: {
    title: "Серия автомобилей",
    description:
      "Добавьте в свою коллекцию атмосферу постапокалиптического экшена с набором 12GO 95005 CAR SERIES. Этот премиальный конструктор включает два детализированных кастомных автомобиля, вдохновлённых суровыми машинами из дистопической пустоши. В наборе 1,726 точно изготовленных деталей, которые обеспечивают увлекательный процесс сборки и позволяют создать две эффектные модели для демонстрации, наполненные агрессивными элементами дизайна и механическими деталями.\n\nКаждый автомобиль отличается уникальными элементами оформления: открытыми двигателями, усиленной бронёй, увеличенными выхлопными системами, оборудованием на крыше, кастомными аксессуарами и детализированным салоном. Более крупная внедорожная машина оснащена огромными шинами, увеличенным дорожным просветом и эффектными задними флагами, а второй маслкар сочетает классический силуэт кузова с сильно модифицированной постапокалиптической внешностью.\n\nМодели выполнены с модульными секциями, поэтому отдельные панели кузова можно снимать, чтобы рассмотреть детальную конструкцию внутри. Богатая механическая детализация, реалистичные элементы кабины и выразительный дизайн делают этот набор превосходным украшением любой коллекции.\n\nЕсли вы увлекаетесь кастомными автомобилями, транспортом в стиле экшен или просто любите сложные конструкторы, 12GO 95005 CAR SERIES подарит увлекательный процесс сборки и впечатляющий результат, достойный демонстрации.",
    highlightsTitle: "Ключевые особенности",
    features: [
      "1,726 высококачественных деталей конструктора",
      "В комплекте два кастомных постапокалиптических автомобиля",
      "Высокодетализированные двигатели и механические компоненты",
      "Модульная конструкция для удобной демонстрации и доступа к деталям",
      "Детализированные салоны с реалистичными элементами кабины",
      "Агрессивный внедорожный дизайн с увеличенными шинами и кастомными аксессуарами",
      "Модели с премиальной визуальной детализацией, достойные демонстрации",
      "Совместимы с конструкторами других ведущих брендов",
      "Идеальный выбор для коллекционеров, любителей автомобилей и опытных конструкторов",
      "Увлекательный и rewarding процесс сборки для детей старшего возраста и взрослых",
    ],
    specsTitle: "Характеристики товара",
    specs: [
      "<li><strong>Бренд:</strong> 12GO</li>",
      "<li><strong>Модель:</strong> CAR SERIES</li>",
      "<li><strong>Номер товара:</strong> 95005</li>",
      "<li><strong>Количество деталей:</strong> 1726+ деталей</li>",
      "<li><strong>Рекомендуемый возраст:</strong> 14+</li>",
    ],
  },

} as const;

function buildLocaleHtml(locale: keyof typeof COPY): string {
  const c = COPY[locale];
  return `<h1>${c.title}</h1>

${paragraphs(c.description)}

<h2>${c.specsTitle}</h2>

<ul>
${c.specs.join("\n")}
</ul>

<h2>${c.highlightsTitle}</h2>

${featureList([...c.features])}`;
}

export const RICH_PRODUCT_COPY_95005: LocalizedCopy = {
  en: buildLocaleHtml("en"),
  pl: buildLocaleHtml("pl"),
  de: buildLocaleHtml("de"),
  es: buildLocaleHtml("es"),
  fr: buildLocaleHtml("fr"),
  nl: buildLocaleHtml("nl"),
  zh: buildLocaleHtml("zh"),
  it: buildLocaleHtml("it"),
  ru: buildLocaleHtml("ru"),
};
